export default __webpack_public_path__ + "static/stakes-905d44ff9f707c0ac941e65cf3adecd7.png";